
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IconFilter from "@/components/common/icon/IconFilter.vue";
import Multiselect from "vue-multiselect";
import { Getter } from "vuex-class";
import {
  CashOrderSendStatusEnum,
  ICashOrderSendStatus,
  ICountry,
  IMonitorsFilterModel,
  IUserDetailData,
} from "@/entities";
import { IPageResponse } from "@/services";

@Component({
  name: "MonitorsFilter",
  components: { IconFilter, Multiselect },
})
export default class MonitorsFilter extends Vue {
  @Getter("getLoggedUser") getLoggedUser!: IUserDetailData;
  @Getter("getCountriesPage") countriesPage!: IPageResponse<ICountry>;
  @Prop({ required: true }) params!: IMonitorsFilterModel;
  paramsEdit = { ...this.params };
  visible = false;
  sendStatusOptions: ICashOrderSendStatus[] = [
    { sendStatus: CashOrderSendStatusEnum.PENDING_SENT, label: this.$t("label.pending_sent") },
    { sendStatus: CashOrderSendStatusEnum.SENT, label: this.$t("label.sent") },
    { sendStatus: CashOrderSendStatusEnum.CANCELED, label: this.$t("label.cancelled") },
    { sendStatus: CashOrderSendStatusEnum.FAILED, label: this.$t("label.failed") },
  ];

  @Watch("params", { deep: true })
  onParamsChange(newParams: IMonitorsFilterModel): void {
    this.paramsEdit = { ...newParams };
  }

  doFilter(): void {
    this.$emit("update:params", { ...this.paramsEdit });
    this.visible = false;
    this.$emit("filter");
  }

  doCleanUp(): void {
    this.paramsEdit = {
      countries: [],
      sendStatuses: [CashOrderSendStatusEnum.FAILED, CashOrderSendStatusEnum.PENDING_SENT],
      serviceCode: "",
      clientCodeOrDesc: "",
      subclientCodeOrDesc: "",
      servicepointCodeOrDesc: "",
      usernameOrId: "",
    };

    this.$emit("update:params", { ...this.paramsEdit });
    this.visible = false;
    this.$emit("filter");
  }

  get countryOptions(): ICountry[] {
    return this.countriesPage?.content || [];
  }

  get countriesSelected(): ICountry[] {
    return (
      this.countryOptions.filter((option) => this.paramsEdit.countries?.includes(option.code!)) ||
      []
    );
  }

  set countriesSelected(selected: ICountry[]) {
    this.paramsEdit.countries = selected.map((option) => option.code!);
  }

  get sendStatusesSelected(): ICashOrderSendStatus[] {
    return (
      this.sendStatusOptions.filter((option) =>
        this.paramsEdit.sendStatuses?.includes(option.sendStatus)
      ) || []
    );
  }

  set sendStatusesSelected(selected: ICashOrderSendStatus[]) {
    this.paramsEdit.sendStatuses = selected.map((option) => option.sendStatus);
  }

  get filterLength(): number {
    let length = 0;
    if (this.params.sendStatuses?.length) length++;
    if (this.params.countries?.length) length++;
    if (this.params.serviceCode) length++;
    if (this.params.clientCodeOrDesc) length++;
    if (this.params.subclientCodeOrDesc) length++;
    if (this.params.servicepointCodeOrDesc) length++;
    if (this.params.usernameOrId) length++;
    return length;
  }

  get isAdmin(): boolean {
    return this.getLoggedUser.admin || false;
  }
}
